// src/pages/AdminDashboard.js
import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  doc,
  addDoc,
} from "firebase/firestore";
import { db } from "../Firebase/Config.js";
import "./AdminDashboard.css";
import { Link } from "react-router-dom";
import InvoiceForm from "../components/InvoiceForm"; // adjust the path as needed

function AdminDashboard() {
  const [requests, setRequests] = useState([]);
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [currentRequest, setCurrentRequest] = useState(null);
  const handleInvoiceSubmit = async (invoiceData) => {
    if (!currentRequest) return;
    try {
      const { uid, id: estimateId } = currentRequest;
      const invoiceRef = collection(db, "users", uid, "invoices");
      await addDoc(invoiceRef, {
        ...invoiceData,
        estimateId,
        createdAt: new Date(),
      });
      alert("Invoice created!");
      setInvoiceOpen(false);
      setCurrentRequest(null);
    } catch (err) {
      alert("Failed to create invoice: " + err.message);
    }
  };

  useEffect(() => {
    const q = query(collection(db, "estimates"), orderBy("timestamp", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const requestsData = [];
      querySnapshot.forEach((doc) => {
        requestsData.push({ id: doc.id, ...doc.data() });
      });
      setRequests(requestsData);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="admin-dashboard">
      <h1>Service Requests</h1>
      <div className="requests-list">
        {requests.length === 0 && <p>No requests yet.</p>}
        {requests.map((request) => (
          <div key={request.id} className="request-card">
            <h3>{request.name}</h3>
            <p>
              <strong>Email:</strong>{" "}
              <a href={`mailto:${request.email}`}>{request.email}</a>
            </p>
            <p>
              <strong>Phone:</strong> {request.phone}
            </p>
            <p>
              <strong>Description:</strong> {request.description}
            </p>
            <p>
              <strong>Status:</strong> {request.status || "Pending"}
            </p>
            <p>
              <strong>UID:</strong> {request.uid || <em>Not available</em>}
            </p>
            <p>
              <strong>Display Name:</strong>{" "}
              {request.displayName || <em>Not provided</em>}
            </p>
            {/* "Message User" link now appears in the card */}
            {request.uid && (
              <p>
                <Link to={`/admin/chat/${request.uid}`}>Message User</Link>
              </p>
            )}
            {request.uid && (
              <button
                style={{ margin: "0.5rem 0" }}
                onClick={() => {
                  setCurrentRequest(request);
                  setInvoiceOpen(true);
                }}
              >
                Generate Invoice
              </button>
            )}
            {request.imageURLs && request.imageURLs.length > 0 && (
              <div className="image-previews">
                <strong>Uploaded Images:</strong>
                <div className="image-list">
                  {request.imageURLs.map((url, i) => (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={i}
                    >
                      <img
                        src={url}
                        alt={`User Upload ${i + 1}`}
                        className="preview-image"
                      />
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminDashboard;
